import AppIcons from "./appIcons";
import constants from "./constantsUtil";
import { isMobile } from "./responsiveUtil";

const whyLoanOptions = [
  {
    icon: AppIcons.icPaperLess,
    title: "100% Paperless Loan Process",
    desc: "Are you looking for loans for women business owners? With Mahila Money loan app, you can complete your loan application process online through our user-friendly loan app. You can avail a business loan for women without lengthy paperwork and multiple visits to the bank. This means less hassle and more time to focus on your business.",
  },
  {
    icon: AppIcons.icVersatileLoan,
    title: "Versatile Loan Options",
    desc: "At Mahila Money we provide women entrepreneurs loan or small business loans for women tailored to various business requirements. Whether you need a short-term loan to cover immediate expenses or a loan for a longer tenure for extended business needs, we've got you covered with our business loans for small businesses.",
  },
  {
    icon: AppIcons.icNoCollateral,
    title: "No Collateral Required",
    desc: "At Mahila Money loan app, we trust in your ability to succeed on your own terms. You don’t need to pledge any assets or seek signatures from male family members to secure a business loan for women. This independence helps you to take complete control of your business finances.",
  },
  {
    icon: AppIcons.icFullyTransparent,
    title: "Fully Transparent",
    desc: "Our digital-first approach ensures a 100% smooth and efficient women entrepreneurs loan application process. From filling out the form to submitting documents and receiving approval, every step is handled online. This streamlined process saves you time and effort, allowing you to concentrate on growing your business. If you're seeking the best small business loan, our platform offers a seamless experience tailored to your needs.",
  },
];

const loanOfferings = [
  {
    icon: AppIcons.imgStarterLoan,
    loanAmount: "₹ 10,000 - ₹ 1,00,000",
    title: "My Business <br/> Starter Loan",
    tenure: "6 months to 12 months",
    idealFor:
      "New businesses (at least 1+ years of operation) or small entrepreneurs needing initial funds to get off the ground.",
    interestRate: "16% - 25%",
  },
  {
    icon: AppIcons.imgGrowMyLoan,
    title: "Grow My <br/> Business Loan",
    tenure: "6 months to 12 months",
    loanAmount: "₹ 1,00,000 - ₹ 5,00,000",
    interestRate: "16% - 25%",
    idealFor:
      "Small to medium-sized enterprises for working capital, inventory purchase, or short-term projects.",
  },
  {
    icon: AppIcons.imgSkyLoan,
    tenure: "24 months to 60 months",
    loanAmount: "₹ 5,00,000 - ₹ 25,00,000",
    title: "Sky is the <br/> Limit Loan",
    interestRate: "16% - 25%",
    idealFor:
      "Established businesses that want to make big investments, like expanding operations, buying equipment, or launching large-scale marketing campaigns.",
  },
];

const loanEligibilityOrDocuments = [
  {
    title: "Eligibility Criteria",
    isRight: false,
    features: [
      "Women-only owned businesses",
      "Indian citizen",
      "Above 18 years",
      "Business Vintage 1+ year",
      "Cibil Score 700+",
    ],
  },
  {
    title: "Documents Required",
    isRight: true,
    features: [
      "Photo Identity: PAN Card / Aadhar Card & Selfie",
      "Address proof: PAN Card / Aadhar Card / Driving Licence / Voter ID ",
      "Business Proof: Business Registration Certificate / Udhyam / GST ",
      "Bank statement: Latest six months",
    ],
  },
];

const emiAmountMarks = [
  {
    displayText: "₹ 10,000",
    displayValue: 10000,
    value: 0,
    label: "₹10k",
  },
  {
    displayText: "₹ 50,000",
    displayValue: 50000,
    value: 1,
    label: "₹50k",
  },
  {
    displayText: "₹ 2,00,000",
    displayValue: 200000,
    value: 2,
    label: "₹2L",
  },
  {
    displayText: "₹ 5,00,000",
    displayValue: 500000,
    value: 3,
    label: "₹5L",
  },
  {
    displayText: "₹ 8,00,000",
    displayValue: 800000,
    value: 4,
    label: "₹8L",
  },
  {
    displayText: "₹ 10,00,000",
    displayValue: 1000000,
    value: 5,
    label: "₹10L",
  },
  {
    displayText: "₹ 12,00,000",
    displayValue: 1200000,
    value: 6,
    label: "₹12L",
  },
  {
    displayText: "₹ 15,00,000",
    displayValue: 1500000,
    value: 7,
    label: "₹15L",
  },
  {
    displayText: "₹ 20,00,000",
    displayValue: 2000000,
    value: 8,
    label: "₹20L",
  },
  {
    displayText: "₹ 25,00,000",
    displayValue: 2500000,
    value: 9,
    label: "₹25L",
  },
];

const interestRateMarks = [
  {
    displayText: "16%",
    displayValue: 16,
    value: 0,
    label: "16%",
  },
  {
    displayText: "18%",
    displayValue: 18,
    value: 1,
    label: "18%",
  },
  {
    displayText: "20%",
    displayValue: 20,
    value: 2,
    label: "20%",
  },
  {
    displayText: "22%",
    displayValue: 22,
    value: 3,
    label: "22%",
  },
  {
    displayText: "25%",
    displayValue: 25,
    value: 4,
    label: "25%",
  },
];

const tenureMarks = [
  {
    displayText: "6 months",
    displayValue: 6 / 12 /* converting in year */,
    value: 0,
    label: "6m",
  },
  {
    displayText: "10 months",
    displayValue: 10 / 12 /* converting in year */,
    value: 1,
    label: "10m",
  },
  {
    displayText: "1 year",
    displayValue: 1,
    value: 2,
    label: "1y",
  },
  {
    displayText: "2 years",
    displayValue: 2,
    value: 3,
    label: "2y",
  },
  {
    displayText: "3 years",
    displayValue: 3,
    value: 4,
    label: "3y",
  },
  {
    displayText: "4 years",
    displayValue: 4,
    value: 5,
    label: "4y",
  },
  {
    displayText: "5 years",
    displayValue: 5,
    value: 6,
    label: "5y",
  },
];

const applyForLoanSteps = [
  {
    title: "Step 1: Download the app",
    desc: "Download the Mahila Money app from Google Play store.",
  },
  {
    imgUrl: AppIcons.imgStepsForApply1,
    width: isMobile ? 100 : 140,
    height: isMobile ? 96 : 134,
  },
  {
    imgUrl: AppIcons.imgStepsForApply2,
    width: isMobile ? 120 : 158,
    height: isMobile ? 100 : 131,
  },
  {
    title: "’Step 2: Go to  ‘Loans for your business",
    desc: ".Fill in your loan application",
  },

  {
    title: "Step 3: Submit your application",
    desc: "Share your documents and submit your application.",
  },
  {
    imgUrl: AppIcons.imgStepsForApply3,
    width: isMobile ? 100 : 134,
    height: isMobile ? 94 : 125,
  },
];

const readyToGrowSteps = [
  {
    img: AppIcons.imgGrowStep1,
    title: "Join Mahila Money Community",
    desc: "Connect with like-minded women entrepreneurs through the Mahila Money loan app. Share ideas, seek advice, and support each other's business journeys.",
  },
  {
    img: AppIcons.imgGrowStep2,
    title: "Collaborate and Grow Together",
    desc: "Engage in meaningful conversations, attend virtual meetups, and find mentorship and partnership opportunities on the Mahila Money loan app.",
  },
  {
    img: AppIcons.imgGrowStep3,
    title: "Experience Belongings & Support",
    desc: "Be part of a supportive network that celebrates your success. With Mahila Money, access the best business loans for small business owners and watch your dreams become reality.",
  },
];

const loanFaqsList = [
  {
    question: "How can I get a business loan for women?",
    answer:
      "If you are looking for small business loans for women then simply complete the loan application on the Mahila Money loan App, submit your documents, and that's it! Our team will get in touch with you to assist you in the process.",
  },
  {
    question: "Where do I get the money after loan approval?",
    answer:
      "Once your loan application is approved and processed, the funds will be transferred to your bank account - shared on the loan application form.",
  },
  {
    question: "How do I check about the status of my loan?",
    answer:
      "<p>To check the status of your loan, contact customer care. Here are details of customer care: <br />Email: customercare@mahila.money<br />Whatsapp: 9810198994 <br />Call: 080-95171600</p>",
  },
  {
    question:
      "I do not have a primary savings or current account with any bank. What should I do?",
    answer:
      "Mahila Money is about women's progress and financial independence.  If you do not have your own bank account, we urge you to open one through any bank of your choice.",
  },
  {
    question:
      "What are the documents required to apply for a business loan for women?",
    answer:
      "<p>You are requested to submit the following documents:<ol> <li>Recent photograph/selfie </li>  <li> Front and back of Aadhar Card</li>  <li> Pancard </li> <li>Bank Statement of past 3-6 months.</li> </ol> </p>",
  },
];

async function fetchImpactStories() {
  const stories = await fetch(constants.impactStoriesApiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => res.json());
  return stories;
}

const calculateFlatInterestEMI = (principalAmount, interestRate, tenure) => {
  const P = parseFloat(principalAmount);
  const R = parseFloat(interestRate) / 100;
  const T = parseFloat(tenure);

  if (isNaN(P) || isNaN(R) || isNaN(T) || P <= 0 || R <= 0 || T <= 0) {
    alert("Please enter valid positive numbers");
    return;
  }

  const totalInterestAmount = P * R * T;
  const emiAmount = (P + totalInterestAmount) / (T * 12);
  const totalAmountToPay = P + totalInterestAmount;

  return {
    emi: parseInt(emiAmount),
    totalInterest: parseInt(totalInterestAmount),
    totalAmt: parseInt(totalAmountToPay),
  };
};

const calculateReducingInterestEMI = (
  principal,
  annualInterestRate,
  tenureYears
) => {
  const P = parseFloat(principal);
  const annualRate = parseFloat(annualInterestRate);
  const T = parseFloat(tenureYears);

  if (
    isNaN(P) ||
    isNaN(annualRate) ||
    isNaN(T) ||
    P <= 0 ||
    annualRate <= 0 ||
    T <= 0
  ) {
    alert("Please enter valid positive numbers");
    return;
  }

  const r = annualRate / 100 / 12; // Monthly interest rate
  const n = T * 12; // Total number of payments (months)

  // EMI Calculation
  const emiAmount = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);

  // Total Amount and Interest Calculation
  const totalAmountToPay = emiAmount * n;
  const totalInterestAmount = totalAmountToPay - P;

  return {
    redEmi: parseInt(emiAmount),
    redTotalInterest: parseInt(totalInterestAmount),
    redTotalAmt: parseInt(totalAmountToPay),
  };
};

export {
  whyLoanOptions,
  loanOfferings,
  loanEligibilityOrDocuments,
  emiAmountMarks,
  interestRateMarks,
  tenureMarks,
  applyForLoanSteps,
  readyToGrowSteps,
  calculateFlatInterestEMI,
  calculateReducingInterestEMI,
  loanFaqsList,
  fetchImpactStories,
};
